import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const api = {
  me: () => client.get("/auth/me").then((r) => r.data),
  googleSession: (session_id) =>
    client.post("/auth/google-session", { session_id }).then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),

  getProfile: () => client.get("/profile").then((r) => r.data),
  updateProfile: (data) => client.put("/profile", data).then((r) => r.data),

  listEntries: () => client.get("/entries").then((r) => r.data),
  getEntry: (date) => client.get(`/entries/${date}`).then((r) => r.data),
  saveEntry: (date, data) => client.put(`/entries/${date}`, data).then((r) => r.data),

  listPhotos: () => client.get("/photos").then((r) => r.data),
  savePhoto: (data) => client.post("/photos", data).then((r) => r.data),
  deletePhoto: (week, angle) => client.delete(`/photos/${week}${angle ? `?angle=${encodeURIComponent(angle)}` : ""}`).then((r) => r.data),

  // Web Push
  getVapidPublicKey: () => client.get("/push/vapid-public-key").then((r) => r.data),
  pushSubscribe: (data) => client.post("/push/subscribe", data).then((r) => r.data),
  pushUnsubscribe: (data) => client.post("/push/unsubscribe", data).then((r) => r.data),
  pushTest: (data = {}) => client.post("/push/test", data).then((r) => r.data),

  // Widget
  getWidgetToken: () => client.get("/widget/token").then((r) => r.data),
};
